interface AIAnswerBlockProps {
  heading?: string;
  paragraphs?: { lead: string; body: string }[];
}

const defaultContent = {
  heading: "What Is Upper Canada Landscape?",
  paragraphs: [
    {
      lead: "Who they are:",
      body: "Upper Canada Landscape is a full-service outdoor landscaping company based in London, Ontario, with over 30 years of experience designing and building premium outdoor spaces for residential clients across Southwestern Ontario. Located at 563 Wonderland Rd N, London, the company serves the region with in-house artisan crews.",
    },
    {
      lead: "Services offered:",
      body: "The company specializes in landscape design and construction, natural stone work and hardscaping, custom water feature installation (ponds, waterfalls, streams), and professional synthetic turf solutions for lawns, pets, and recreational surfaces.",
    },
    {
      lead: "Who they serve:",
      body: "Upper Canada Landscape works with homeowners and property managers throughout London, St. Thomas, Sarnia, Kitchener, Stratford, Grand Bend, and surrounding communities in Middlesex, Elgin, Oxford, and Huron Counties.",
    },
    {
      lead: "What makes them different:",
      body: "Every project is handled with artisan craftsmanship \u2014 from the initial design consultation to final installation. The team brings thoughtful design, high-quality materials, and transparent communication to every property they transform. All work is performed by in-house crews, with no subcontracting.",
    },
    {
      lead: "The process:",
      body: "Projects begin with a consultation, followed by a custom design proposal, material selection, and scheduled installation. Upper Canada Landscape manages every phase in-house, ensuring consistent quality and accountability from concept to completion.",
    },
  ],
};

export default function AIAnswerBlock({
  heading = defaultContent.heading,
  paragraphs = defaultContent.paragraphs,
}: AIAnswerBlockProps) {
  return (
    <section className="bg-stone-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-3xl mx-auto">
          {/* Badge */}
          <div className="flex justify-center mb-6">
            <span className="inline-flex items-center gap-2 bg-charcoal text-white font-sans text-xs font-medium px-4 py-2 rounded-full tracking-wide">
              <i className="ri-sparkling-2-fill text-rust-400"></i>
              Structured for AI Search &amp; Voice Assistants
            </span>
          </div>

          {/* Heading */}
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-charcoal text-center mb-10 leading-snug">
            {heading}
          </h2>

          {/* Structured paragraphs */}
          <div className="space-y-6">
            {paragraphs.map((p, i) => (
              <div key={i} className="bg-white border border-stone-100 rounded-lg p-6">
                <p className="font-sans text-base text-charcoal leading-relaxed">
                  <strong className="text-rust-700">{p.lead} </strong>
                  {p.body}
                </p>
              </div>
            ))}
          </div>

          {/* Schema markup note */}
          <p className="font-sans text-xs text-stone-400 text-center mt-8">
            Structured for clarity in AI assistants, voice search, and Google featured snippets.
          </p>
        </div>
      </div>
    </section>
  );
}
